/* Auto-generated, do not edit */
import React from 'react';

interface Props {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

function Avatar_icn_avatar20(props: Props) {
    const { size = 14, width = size, height = size, fill = '' } = props;
    return (
      <svg viewBox="0 0 24 24" fill="#27A2A8" width={ `${ width }px` } height={ `${ height }px` } ><path d="M21 13c0-1.6-1.2-3.3-3-4 0-2.8-2.1-6-6-6S6 6.2 6 9c-1.8.7-3 2.4-3 4 0 2.7 2.6 4.4 5.2 4.9.5 1.2 2 2.1 3.8 2.1s3.3-.9 3.8-2.1c2.6-.5 5.2-2.2 5.2-4.9z" opacity=".3"/><path d="M12 21c-2.8 0-5-1.8-5-4h2c0 1.1 1.3 2 3 2s3-.9 3-2h2c0 2.2-2.2 4-5 4z"/><path d="m15.1 19-.1-2c2.1-.1 5.1-1.5 5.1-4 0-1.2-1-2.5-2.4-3.1l-.7-.2V9c0-2.1-1.6-5-5-5S7 6.9 7 9v.7l-.6.2C5 10.5 4 11.8 4 13c0 2.5 3 3.9 5.1 4L9 19c-3.4-.2-7-2.4-7-6 0-1.9 1.2-3.7 3-4.7C5.3 5.1 7.9 2 12 2s6.7 3.1 7 6.3c1.8 1 3 2.8 3 4.7 0 3.6-3.6 5.8-6.9 6z"/><path d="M17 13h-2c0-1.1-1.4-2-3-2s-3 .9-3 2H7c0-2.2 2.2-4 5-4s5 1.8 5 4zm-7 4v-2c2.5 0 3.9-.8 4-1.1l2 .1c0 2.1-3.1 3-6 3z"/><path d="M19 7H5l-2 4h18l-2-4zM9 10c-1.1 0-2-.4-2-1s.9-1 2-1 2 .4 2 1-.9 1-2 1zm6 0c-1.1 0-2-.4-2-1s.9-1 2-1 2 .4 2 1-.9 1-2 1z"/><path d="m21.2 4-.8.5c-1.4.8-1.9 2.5-1.1 3.9l.5.6.7-.4c1.4-.8 1.9-2.5 1.1-3.9l-.4-.7z"/></svg>
  );
}

export default Avatar_icn_avatar20;
